import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var segmentedControl = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1ubl9639',variantClassNames:{fullWidth:{true:'fx_2d2fb1e5_1ubl963a',false:'fx_2d2fb1e5_1ubl963b'},size:{xsmall:'fx_2d2fb1e5_1ubl963c',small:'fx_2d2fb1e5_1ubl963d','default':'fx_2d2fb1e5_1ubl963e',large:'fx_2d2fb1e5_1ubl963f'}},defaultVariants:{fullWidth:false,size:'default'},compoundVariants:[]});
var segmentedControlPadding = 'var(--fx_2d2fb1e5_1ubl9631)';

export { segmentedControl, segmentedControlPadding };
//# sourceMappingURL=segmentedControl.vanilla.mjs.map
